import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { categories } from "@/mocks/categories";
import { usePageMeta } from "@/hooks/usePageMeta";

const values = [
  {
    icon: "ri-live-line",
    title: "多元内容",
    desc: "覆盖娱乐表演、网络游戏、才艺展示与聊天互动，满足不同兴趣的观看需求。",
  },
  {
    icon: "ri-hd-line",
    title: "高清稳定",
    desc: "致力于提供清晰流畅的观看体验，让每一场直播都能稳定呈现。",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "实时互动",
    desc: "弹幕、点赞与分享，让你在观看的同时与主播和观众一起参与其中。",
  },
  {
    icon: "ri-shield-check-line",
    title: "友善社区",
    desc: "倡导文明发言与互相尊重，共同营造健康的直播互动氛围。",
  },
];

const rules = [
  "尊重主播与其他观众，不发布攻击、谩骂或歧视性内容。",
  "不传播违法违规、虚假或侵权信息，共同维护清朗的网络空间。",
  "直播内容与弹幕均为演示数据，请勿将其作为真实信息传播。",
  "遇到问题或建议，欢迎通过下方联系方式与我们取得联系。",
];

export default function About() {
  usePageMeta({
    title: "关于我们 - 蜜梨直播",
    description:
      "了解蜜梨直播的平台定位、内容范围与使用规则。蜜梨直播专注于提供多元化、高质量的互动直播体验。",
    keywords: "关于蜜梨直播,直播平台介绍,蜜梨直播定位,互动直播",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />

      <main className="w-full flex-1 px-4 py-6 md:px-8">
        <section className="overflow-hidden rounded-lg bg-foreground-950 px-6 py-12 md:px-12 md:py-16">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-1.5 text-xs font-semibold text-background-50">
            <i className="ri-information-line text-base" />
            关于蜜梨直播
          </span>
          <h1 className="mt-5 max-w-3xl font-heading text-2xl font-extrabold leading-tight text-background-50 md:text-4xl">
            让每一次观看，都成为一场轻松愉快的互动
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            蜜梨直播是一家专注于提供多元化、高质量直播内容的互动直播平台，内容涵盖娱乐表演、网络游戏、才艺展示以及用户交流互动，致力于为泛娱乐观众、游戏玩家、才艺爱好者与社交活跃的年轻群体带来便捷、愉悦的观看体验。
          </p>
        </section>

        <section className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <h2 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </section>

        <section className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 lg:col-span-2">
            <h2 className="font-heading text-lg font-bold text-foreground-950">平台定位与内容范围</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              蜜梨直播以“现代门户 + 卡片探索”的方式组织内容，帮助用户便捷查找感兴趣的直播频道、参与实时互动、观看高清稳定的直播视频，并发现更多优质主播。
            </p>
            <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3">
              {categories.map((cat) => (
                <div
                  key={cat.key}
                  className="flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2.5 text-sm text-foreground-700"
                >
                  <i className={`${cat.icon} text-base text-primary-500`} />
                  {cat.name}
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-950">联系我们</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              如有合作、内容反馈或任何建议，欢迎通过以下方式与我们取得联系。
            </p>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2.5 text-foreground-700">
                <i className="ri-mail-line text-base text-primary-500" />
                support@mili-live.example.com
              </li>
              <li className="flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2.5 text-foreground-700">
                <i className="ri-feedback-line text-base text-primary-500" />
                feedback@mili-live.example.com
              </li>
              <li className="flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2.5 text-foreground-700">
                <i className="ri-time-line text-base text-primary-500" />
                客服在线：每日 09:00 - 23:00
              </li>
            </ul>
          </div>
        </section>

        <section className="mt-10 rounded-lg border border-background-200 bg-background-50 p-6">
          <h2 className="font-heading text-lg font-bold text-foreground-950">使用规则简述</h2>
          <ul className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
            {rules.map((rule) => (
              <li
                key={rule}
                className="flex items-start gap-2 rounded-md bg-primary-50 px-4 py-3 text-sm leading-relaxed text-foreground-700"
              >
                <i className="ri-checkbox-circle-line mt-0.5 text-base text-primary-500" />
                {rule}
              </li>
            ))}
          </ul>
          <p className="mt-4 text-xs text-foreground-400">
            说明：本站为演示站点，所有直播内容、主播信息与数据均为虚构演示，不代表真实业务。
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
}